import { forwardRef, ButtonProps, Button } from '@chakra-ui/react';

export const GhostButton = forwardRef<ButtonProps, 'button'>((props, ref) => (
  <Button ref={ref} variant='text' {...props} />
));
